import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderGoogleDriveCommon = {
  key: 'googleDrive',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'googleDrive',
    authUrl: 'https://accounts.google.com/o/oauth2/auth',
    tokenUrl: 'https://oauth2.googleapis.com/token',
    scopes: ['https://www.googleapis.com/auth/userinfo.profile', 'email'],
    authParams: {
      include_granted_scopes: true,
    },
  }),
}

export type ProviderGoogleDriveAccountType = {
  email: string
  name: string
}

export enum MimeTypes {
  FOLDER = 'application/vnd.google-apps.folder',
  GOOGLE_DOC = 'application/vnd.google-apps.document',
  GOOGLE_SHEET = 'application/vnd.google-apps.spreadsheet',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
  PDF = 'application/pdf',
  MSG = 'application/vnd.ms-outlook',
  PNG = 'image/png',
  JPEG = 'image/jpeg',
}

export type FileType = {
  id: string
  content?: string
  buffer?: Buffer
  name: string
  mimeType: MimeTypes
  modifiedTime?: string
  folderId?: string
}

export enum GoogleDriveScope {
  Files = 'https://www.googleapis.com/auth/drive.file',
}
